export default __webpack_public_path__ + "static/media/logo.211bc056.svg";